document.querySelectorAll('[data-ws-sticky-bar]').forEach((bar) => {
  const sectionId = bar.dataset.sectionId;
  const productUrl = bar.dataset.url;

  // Fixed-position bar is removed from normal flow, so nothing reserves
  // space for it — without this, it permanently covers the last ~70px of
  // the page (footer links, the final-offer CTA) on mobile with no way to
  // scroll past it. Mirrors the --header-height pattern in theme.liquid.
  const setOffset = () => {
    document.documentElement.style.setProperty('--ws-sticky-bar-height', `${bar.offsetHeight}px`);
  };
  setOffset();
  window.addEventListener('resize', setOffset);

  // Bar starts hidden and only slides in once the visitor has scrolled past
  // the hero section, so it doesn't compete with the hero's own CTA.
  const heroSection = document.querySelector('.ws-product-hero, .ws-inner-circle-hero');
  if (heroSection && 'IntersectionObserver' in window) {
    const heroObserver = new IntersectionObserver(
      ([entry]) => bar.classList.toggle('ws-sticky-bar--visible', !entry.isIntersecting),
      { threshold: 0 }
    );
    heroObserver.observe(heroSection);
  } else {
    bar.classList.add('ws-sticky-bar--visible');
  }

  if (!productUrl || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data || !data.variant) return;

    fetch(`${productUrl}?variant=${data.variant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const updated = html.getElementById(`WsStickyBar-${sectionId}`);
        if (updated) bar.innerHTML = updated.innerHTML;
        setOffset();
      })
      .catch((error) => console.error(error));
  });
});
